<template>
  <a
    href="#"
    role="button"
    class="side-menu__item"
    :class="`${menuData?.selected ? 'active' : ''}`"
    @mouseover="hoverToggleInnerMenuFn($event, menuData)"
    @click="toggleSubmenu($event, menuData, undefined, level)"
  >
    <template v-if="level == 1 && menuData?.selected">
      <span class="shape1"></span>
      <span class="shape2"></span>
    </template>

    <i v-if="menuData?.icon" :class="`${menuData?.icon} side-menu__icon`"></i>

    <span v-if="level" :class="{ 'side-menu__label': level === 1 }">
      {{ $t(menuData.title) }}

      <span v-if="menuData.badge" :class="`badge ${menuData?.badgeColor} ms-1`">
        {{ menuData.badge }}
      </span>
    </span>

    <i class="fe fe-chevron-right side-menu__angle"></i>
  </a>
  <ul
    class="slide-menu"
    :class="`${menuData.active && level == 1 ? 'double-menu-active' : ''} child${level} ${menuData?.dirchange ? 'force-left' : ''}`"
    :style="menuData.active ? 'display : block' : ''"
  >
    <li v-if="level <= 1" class="slide side-menu__label1">
      <a href="javascript:void(0)">{{ $t(menuData.title) }}</a>
    </li>

    <li
      v-for="(firstLevelMenuItem, subIndex) in menuData.children"
      :key="subIndex"
      :class="{
        slide__category: firstLevelMenuItem.headTitle,
        'has-sub': firstLevelMenuItem?.type == 'sub',
        active: firstLevelMenuItem?.selected,
        slide:
          firstLevelMenuItem?.type === 'empty' ||
          firstLevelMenuItem?.type == 'link' ||
          firstLevelMenuItem?.type == 'sub'
      }"
    >
      <template v-if="firstLevelMenuItem?.type === 'link'">
        <a
          v-if="firstLevelMenuItem.external"
          :href="firstLevelMenuItem.path"
          target="_blank"
          class="side-menu__item"
          :class="`${firstLevelMenuItem?.selected ? 'active' : ''}`"
        >
          {{ $t(firstLevelMenuItem.title) }}
          <span
            v-if="firstLevelMenuItem.badge"
            :class="`badge ${firstLevelMenuItem.badgeColor} ms-1`"
          >
            {{ firstLevelMenuItem.badge }}
          </span>
        </a>
        <router-link
          v-else-if="checkMenuAccess(firstLevelMenuItem)"
          :to="firstLevelMenuItem.path"
          class="side-menu__item"
          :class="`${firstLevelMenuItem?.selected ? 'active' : ''}`"
        >
          {{ $t(firstLevelMenuItem.title) }}
          <span
            v-if="firstLevelMenuItem.badge"
            :class="`badge ${firstLevelMenuItem.badgeColor} ms-1`"
          >
            {{ firstLevelMenuItem.badge }}
          </span>
        </router-link>
      </template>
      <template v-if="firstLevelMenuItem?.type === 'empty'">
        <a href="javascript:;" class="side-menu__item">
          {{ $t(firstLevelMenuItem.title) }}
          <span
            v-if="firstLevelMenuItem.badge"
            :class="`badge ${firstLevelMenuItem.badgeColor} ms-1`"
          >
            {{ firstLevelMenuItem.badge }}
          </span>
        </a>
      </template>
      <template v-if="checkSubMenuAccess(firstLevelMenuItem)">
        <RecursiveMenu
          :menu-data="firstLevelMenuItem"
          :toggle-submenu="toggleSubmenu"
          :hover-toggle-inner-menu-fn="hoverToggleInnerMenuFn"
          :level="level + 1"
        />
      </template>
    </li>
  </ul>
</template>

<script>
import { ROLES_APPLICATION, ROLES_APPLICATION_MODULE } from '@/core/constants/roles';
import { checkUserHaveRoles, checkUserHaveSpecificRoles } from '@/core/utils/roles';
import { authStore } from '@/stores/auth';
import { reactive } from 'vue';

export default {
  props: {
    menuData: {
      type: Object,
      required: true
    },
    toggleSubmenu: {
      type: Function,
      required: true
    },
    hoverToggleInnerMenuFn: {
      type: Function,
      required: true
    },
    level: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      auth: reactive(authStore()),
      ROLES_APPLICATION,
      ROLES_APPLICATION_MODULE
    }
  },
  computed: {
    rolesUserAuth() {
      return this.auth.roles
    }
  },
  created() {
    // Access and check propData in the created hook
  },
  methods: {
    checkUserAuthHaveRoles(roles) {
      return checkUserHaveRoles(roles, this.rolesUserAuth)
    },
    checkUserAuthHaveSpecificRoles(module, roles) {
      return checkUserHaveSpecificRoles(this.rolesUserAuth, module, roles)
    },
    checkMenuAccess(menu) {
      if (!menu.roleVerification && !menu.specificRoleVerification) {
        return true
      }

      if (menu.roleVerification) {
        return this.checkUserAuthHaveRoles([
          ROLES_APPLICATION.ADMIN,
          ROLES_APPLICATION.ACCOUNTING_SOURCING
        ])
      }

      if (menu.specificRoleVerification) {
        return this.checkUserAuthHaveSpecificRoles(menu.title, ROLES_APPLICATION_MODULE)
      }

      return false
    },
    checkSubMenuAccess(menu) {
      if (menu?.type !== 'sub') {
        return false
      }

      return (
        !menu.specificRoleVerification ||
        this.checkUserAuthHaveSpecificRoles(menu.title, ROLES_APPLICATION_MODULE)
      )
    }
  }
}
</script>
